(function () {

    angular
        .module('smartertoolsApp',
            [
                'angular-cache',
                'ngAnimate',
                'ngCsv',
                'ngMessages',
                'ngRoute',
                'ngSanitize',
                'ngFileUpload',
                'payment',
                'stControls',
                'ui.autofocus',
                'ui.bootstrap',
                'ui.router',
                'angularSpinner'
            ])
        .config(['$httpProvider', httpProvider])
        .config(['$locationProvider', locationProvider])
        .factory('httpRequestAuthenticationInterceptor', httpRequestAuthenticationInterceptor);

    function httpProvider($httpProvider) {
        $httpProvider.interceptors.push('httpRequestAuthenticationInterceptor');
    }

    function locationProvider($locationProvider) {
        $locationProvider.hashPrefix('');
    }

    function httpRequestAuthenticationInterceptor($injector, $window, $rootScope, $q) {
        return {
            request: function ($config, authenticationService) {
                const token = sessionStorage.getItem('stAuthToken');
                if (token) {
                    $config.headers['Authorization'] = 'BEARER ' + token;
                }
                return $config;
            },
            responseError: function (rejection) {
                if (rejection.status == 401 && rejection.config.url.indexOf(apiRootUrl) > -1) {
                    console.log(`Forward to login page: Status${rejection.status} URL: ${rejection.config.url}`);

                    const authService = $injector.get('authenticationService');
                    authService.clearSession();

                    $window.location.href = '/';
                    return $q.when();
                } else return $q.reject(rejection);
            }
        };
    }

    AOS.init({
        once: true,
        duration: 800,
        offset: 100,
        disable: 'mobile'
    });
})();